const mockStorage = {
  getItem: () => null,
  setItem: () => void 0,
  removeItem: () => void 0,
  key: () => null,
  clear: () => void 0,
  length: 0,
};

/**
 * safeSessionStorage is just a helper that mocks the sessionStorage class outside of a browser context.
 */
export const safeSessionStorage = typeof window === "undefined" ? mockStorage : window.sessionStorage;

/**
 * safeLocalStorage is just a helper that mocks the localStorage class outside of a browser context.
 */
export const safeLocalStorage = typeof window === "undefined" ? mockStorage : window.localStorage;
